//created by Peggy on 2021/7/27
import React from "react";
import {
  LinkedinFilled,
  InstagramFilled,
  FacebookFilled,
} from "@ant-design/icons";

const SocialLayout = () => {
  return (
    <section className="social-follow">
      <div className="flex ">
        <h1>Follow us on social media</h1>
        <span className="flex">
          <a
            rel="noreferrer"
            target="_blank"
            href="https://www.instagram.com/counterpartarts/"
          >
            <InstagramFilled />
          </a>
          <a
            rel="noreferrer"
            target="_blank"
            href="https://www.facebook.com/CounterpartArts/"
          >
            <FacebookFilled />
          </a>
          <a
            rel="noreferrer"
            target="_blank"
            href="https://www.linkedin.com/company/counterpartarts/"
          >
            <LinkedinFilled />
          </a>
        </span>
      </div>
      <a href="https://mailchi.mp/yourcounterpart/counterpart-mailing-list" target="_blank" rel="noreferrer" className="elementor-button-link" role="button">
        <span className="elementor-button-text">Join our mailing list</span>
      </a>
    </section>
  );
};

export default SocialLayout;
